import { browser } from '$app/environment';
import { activeLocale, resolveDisplayLocale } from '$lib/i18n';
import { app } from '$lib/stores/app/store';
import { Page } from '$lib/utils/page';
import { get } from 'svelte/store';
import { pageConditions } from './__config/conditions';
import { policy, policyExceptionHandler } from './-policy';
import { preload } from './_i18n';

export const prerender = true;

/**
 * Loads the page data
 * @param {import('./$types').PageLoadEvent} event - SvelteKit load event.
 * @returns {Promise<{page: Page} | undefined>} - The page data
 */
export async function load(event) {
	if (browser) {
		event.depends('app:locale');
		const locale = resolveDisplayLocale();
		activeLocale.set(locale);
		await preload(locale, get(app).meta.viewerCountry);
		const page = new Page({
			routePath: '/prospect-register',
			policies: { policy, policyExceptionHandler },
			conditions: pageConditions,
		});
		return {
			page,
		};
	}
}
